// import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/generalPages/landing";
import SignIn from "./pages/users/auth/signIn";
import AboutUs from "./pages/generalPages/aboutUs";
import CreateAccount from "./pages/users/auth/create-account";
import Layout from "./pages/generalPages/layout";
import UserLayout from "./pages/users/layout";
import { ToastContainer } from "react-toastify";
import Support from "./pages/generalPages/support";
import Contact from "./pages/generalPages/contact";
import Pricing from "./pages/generalPages/servicePricing";
import SendPasswordResetLink from "./pages/users/auth/sendPasswordResetLink";
import VerifyResetOtp from "./pages/users/auth/verifyResetOtp";
import ResetPassword from "./pages/users/auth/resetPassword";
import CloudServices from "./pages/generalPages/cloudServices";
import ProductPage from "./pages/generalPages/product";
import BlogPage from "./pages/generalPages/blog";
import Cloud_infrastructure from "./pages/generalPages/Cloud_infrastructure";
import Cloud_services from "./pages/generalPages/Cloud_services";
import SingleBlogPage from "./pages/generalPages/SingleBlogPage";
import AdminDashboard from "./pages/admin/blog/AdminDashboard";
import AdminViewBlog from "./pages/admin/blog/AdminViewBlog";
import CreateOrEditBlog from "./pages/admin/blog/CreateOrEditBlog";
import BlogLoginPage from "./pages/admin/blog/BlogLoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { authAPI } from "./hooks/remote/blogApi";
import PrivacyPolicy from './pages/terms/PrivacyPolicy';
import DataProcessing from './pages/terms/DataProcessing';
import SLAs from './pages/terms/SLAs';
import CloudServicesAgreement from './pages/terms/CloudServicesAgreement';
import AcceptableUsePolicy from './pages/terms/AcceptableUsePolicy';
import TermsOfUse from './pages/terms/TermsOfUse';
import CookiePolicy from './pages/terms/CookiePolicy';



function App() {
  return (
    <div className=" bg-[#EEF5FF] dark:bg-[#141D26]">
      <ToastContainer bodyClassName={() => 'toastBody flex items-center text-sm'} 
      position="top-right" limit={1} newestOnTop autoClose={5000} closeOnClick pauseOnHover draggable/>
      <BrowserRouter>
        {/* <LogoutTimer/> */}
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<LandingPage />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/password-reset-link" element={<SendPasswordResetLink />} />
            <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/cloud-services" element={<CloudServices />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/cloud-infrastructure" element={<Cloud_infrastructure />} />
            <Route path="/blog/cloud-services" element={<Cloud_services />} />
            <Route path="/blog/:slug" element={<SingleBlogPage />} />
            {/* Blog Admin Routes - Public Auth Routes */}
            <Route
              path="/blog-admin/login"
              element={
                authAPI.isAuthenticated() ? (
                  <Navigate to="/blog-admin" replace />
                ) : (
                  <BlogLoginPage />
                )
              }
            />
            {/* Blog Admin Routes - Protected Routes */}
            <Route
              path="/blog-admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog-admin/create-blog"
              element={
                <ProtectedRoute>
                  <CreateOrEditBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog-admin/edit-blog/:id"
              element={
                <ProtectedRoute>
                  <CreateOrEditBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog-admin/blogs/:id"
              element={
                <ProtectedRoute>
                  <AdminViewBlog />
                </ProtectedRoute>
              }
            />
            <Route path="/support" element={<Support />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cloud-services-agreement" element={<CloudServicesAgreement />} />
            <Route path="/acceptable-use-policy" element={<AcceptableUsePolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/data-processing" element={<DataProcessing />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/sla" element={<SLAs />} />
          </Route>
          <Route path="*" element={<UserLayout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );

}


export default App;